/* eslint-disable */
export default {
  init() {
    // JavaScript to be fired on all pages
	$(document).ready(function(){
		//Menu burger
		$('.see-more-content__content').each(function(index){
			if($(this).children().length <= 5){
				$($('.btn-see-more')[index]).hide();
			}
			
		})

		$('.menu-burger').click(function(){
			$('body').addClass('no-scroll');
			$('header').addClass('fixed');
			$('.menu-close').removeClass('d-none');
			$('.nav-primary').show();
			setTimeout(function(){
				$('.nav-primary').addClass('open');
			}, 100);
			$(this).addClass('d-none');
		});
		$('.menu-close').click(function(){
			$('body').removeClass('no-scroll');
			$('header').removeClass('fixed');
			$(this).addClass('d-none');
			$('.nav-primary').removeClass('open');
			setTimeout(() => {
				$('.nav-primary').hide();
			}, 400);
			$('.menu-burger').removeClass('d-none');
		});
		//slider 
		$('.slider-content').slick({
			infinite: false,
			prevArrow: '<div class="slick-prev"></div>',
			nextArrow: '<div class="slick-next"></div>',
		});
		function slickInit(){
			$('.see-more-content__content').on('init', function(slick){
				$('.slick-prev').hide();
			})
			let slideSeeMore = $('.see-more-content__content').slick({
				infinite: false,
				slidesToShow: 1,
  				slidesToScroll: 1,
				centerMode: false,
				variableWidth: true,
				prevArrow: '<div class="slick-prev"></div>',
				nextArrow: '<div class="slick-next"></div>',
				mobileFirst: true,
				responsive: [
					{
						breakpoint: 992,
						settings: 'unslick',
					},

					{
						breakpoint: 768,
						settings: {
							slidesToShow: 3,
							slidesToScroll: 3,
						}
					},
					{
						breakpoint: 500,
						settings: {
							slidesToShow: 2,
							slidesToScroll: 2,
						}
					},
				]
			});

  			$('.slick-prev').hide();
			slideSeeMore.on('afterChange', function(event, slick, currentSlide){
				$('.slick-prev').show();
				if (currentSlide === 0) {
					$('.slick-prev').hide();
					$('.slick-next').show();
				}
				else if(slick.currentSlide >= slick.slideCount - slick.options.slidesToShow) {
					$('.slick-prev').show();
					$('.slick-next').hide();
				}
			});
		}
		slickInit();
		$(window).resize(function(){
			if (window.innerWidth < 992) {
				slickInit();
			}
		});
		$('.btn-see-more').click(function(){
			let allParents = $('.toggle-see-more').parent().parent();
			let parent = $(this).parent().parent();
			for(let i = 0; i < allParents.length; i++){
				if(allParents[i] == parent[0]){
					var clicks = $(this).data('clicks');
					if (clicks) {
						$(allParents[i]).find('.toggle-see-more').addClass('d-lg-none');
						let text = $(this).text();
						text = text.replace('moins', 'plus');
						$(this).text(text);
						console.log($(this));
						if($(this).hasClass('minus')){
							$(this).removeClass('minus');
							$(this).addClass('plus');
						}
					} else {
						$(allParents[i]).find('.toggle-see-more').removeClass('d-lg-none');
						let text = $(this).text();
						text = text.replace('plus', 'moins');
						$(this).text(text);
						if($(this).hasClass('plus')){
							$(this).addClass('minus');
							$(this).removeClass('plus');
						}
					}
					$(this).data('clicks', !clicks);
				}
			}
			
		});
		const player = $('.video iframe');
		const playBtn = $('.play-button');
		const videoCover = $('.play-image');
		const lastSrc = player.attr('src')
		let times = 0, playY;
		$(playBtn).click(function(){
			if(times == 0){
				playY = player.attr('src', lastSrc + '&autoplay=1');
				times = 1;
				player.show();
				playBtn.hide();
				videoCover.hide();
			}
		});
	});
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js